/**
 * Parses a Link header to determine if a "next" page exists.
 *
 * The new Task API returns pagination via a Link header like:
 *   <https://api.githubcopilot.com/agents/tasks?page=2&per_page=10>; rel="next"
 *
 * @param linkHeader - The raw Link header value, or null if not present.
 * @returns true if a rel="next" link is present, false if the header exists
 *          but has no next link, or null if the header is absent.
 */
export function parseLinkHeader(linkHeader: string | null | undefined): boolean | null {
  if (!linkHeader) {
    return null
  }

  return /rel="next"/.test(linkHeader)
}
